import { getMimeType, readImageDimensions } from "./upload-file-metadata";
export { getMimeType } from "./upload-file-metadata";
import {captureVideoFrame} from "./helpers/generage-video-preview";
import FileBrowserService from './api/file-browser'
import { IMAGE_TYPE_PRODUCT } from "@frontend/constants/file-upload-images-types";
import router from "@frontend/router";

export const uploadFolderLink = async (files, folderId, isReplace = 0) => {
  const formData = new FormData();
  formData.append("file_info", JSON.stringify(files));
  formData.append("folderId", folderId);
  const {data} = await FileBrowserService.storeExternalResourceToFolderFile(formData);
  return data;
}

export const uploadFolderFile = async (files, folderId, isReplace = 0, includeUploadItems = false) => {
    const fileInfo = []

    for (const key in files) {
        if (key === 'length') {
          continue;
        }

        const file = files[key];
        
        const mimetype = getMimeType(file);

        if (!file.name || !mimetype) {
            continue;
        }

        const fileInfoItem = {
            key,
            name: file.name,
            type: mimetype,
            size: file.size,
            replace_name: file.replace_name ?? '',
        };

        const dimensions = await readImageDimensions(file);
        if (dimensions) {
            fileInfoItem.width = dimensions.width;
            fileInfoItem.height = dimensions.height;
        }

        fileInfo.push(fileInfoItem)

        if (file.company_id) {
            fileInfo[fileInfo.length - 1]['company_id'] = file.company_id
        }
        
        if (mimetype.includes('video')) {
            fileInfo[fileInfo.length - 1]['image'] = await captureVideoFrame(file)
        }
    }

    const formData = new FormData();
    formData.append('file_info', JSON.stringify(fileInfo));
    formData.append('folderId', folderId);
    formData.append('isReplace', isReplace);
    if (includeUploadItems) formData.append('includeUploadItems', '1');
    formData.append('isRootLevel', folderId === 'null' || folderId === null || folderId === undefined ? true : false);

    const {data} = await FileBrowserService.uploadFolderFile(formData);

    return data
}

export const uploadFile = (uploadUrl, file, onProgress, method = "PUT") => new Promise((resolver, rejecter) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
        if (xhr.status === 200) {
            resolver();
        } else {
            const error = new Error(xhr.response);
            rejecter(error);
        }
    };
    xhr.onerror = (error) => {
        rejecter(error);
    };
    xhr.upload.onprogress = (evt) => {
        onProgress?.(evt.loaded / evt.total);
    };
    xhr.open(method, uploadUrl);
    xhr.send(file);
});

export const prepareProductFileForm = (payload) => {
  // Prioritize payload.folderId (from drag operation) over route extraction
  // Only fallback to route extraction if payload.folderId is not provided
  let folderId = null;
  
  if (payload.folderId !== undefined && payload.folderId !== null) {
    // Use the folder ID passed from the drag/upload operation
    folderId = Number(payload.folderId);
  } else {
    // Fallback: extract from current route (for non-drag operations)
    const pathMatch = router.currentRoute.params.pathMatch;
    if (pathMatch) {
      const lastPart = pathMatch.split('/').pop();
      if (!isNaN(Number(lastPart)) && lastPart !== '') {
        folderId = Number(lastPart);
      }
    }
  }
  
  console.log('prepareProductFileForm: Using folder_id:', folderId);
  
  const files = [];
  const replace_file_with_same_name = [];
  
  for (const key in payload.files) {
    if (key === 'length') {
      continue;
    }

    const file = payload.files[key];
    const mimetype = getMimeType(file);

    if (!file.name || !mimetype) {
      continue;
    }

    files.push(file);
    replace_file_with_same_name.push(file.name);
  }

  const formFields = {
    image_type: IMAGE_TYPE_PRODUCT,
    upload_images: files,
    upload_images_url: '',
    company_id: -1,
    replace_file_with_same_name: payload.selected ==  1 ? replace_file_with_same_name : [],
    generated_from_psd: '',
    folder_id: folderId || '', // Use the properly determined folder_id
    convert: 'png',
    max_size: 5000,
    resize: 99,
    dimension_width: 0,
    dimension_height: 0,
    has_dimension_aspect_ratio: false,
    name: '',
    dpi: 75,
    background_remove: payload.isRemoveBackground,
    crop_to_image: payload.isCropToImage,
    is_compress: false,
    is_resize: false,
    is_convert: false,
    is_rename: false,
    is_dpi: false,
  }

  const formData = new FormData();

  for (const key in formFields) {
    const value = formFields[key];

    if (Array.isArray(value)) {
      value.forEach(field => {
        formData.append(`${key}[]`, field);
      });

    } else {
      formData.append(key, value);

    }
  }
  
  return formData;
}
